
import { defineComponent } from "vue";

export default defineComponent({
    name: "Config",
    data() {
        return {};
    },
});
